export const ROOT_CAUSE_ANALYSIS_ACTIONS = {
  ROOT_CAUSE_PAYLOAD : "ROOT_CAUSE_PAYLOAD",
};
